import React, {PureComponent} from 'react';
import {Translate} from 'react-localize-redux';
import {withRouter, NavLink} from 'react-router-dom';
import './style.css';

class NavBar extends PureComponent {
	render() {
		return (
			<Translate>
				{({translate}) => (
					<div className="com-navbar">
						<NavLink className="nav-item" exact to={"/"}>{translate("home")}</NavLink>
						<NavLink className="nav-item" to={"/products"}>{translate("products")}</NavLink>
						{/*<NavLink className="nav-item" to={"/customers"}>{translate("customers")}</NavLink>*/}
						<NavLink className="nav-item" to={"/contact"}>{translate("contact")}</NavLink>
					</div>
				)}
			</Translate>
		);
	}
}

export default withRouter(NavBar);



// WEBPACK FOOTER //
// ./src/04-containers/NavBar/index.js